import * as ACCOUNT from './account';
import * as EXTERNAL from './external';
import * as PROMO from './promo';
import * as STORE from './store';
import * as PLATFORM from './platform';
import * as USER from './user';
import * as CMS from './cms';
import * as CUSTOMER from './customer';
import * as DOCUMENT from './document';
import * as FAQ from './faq';
import * as EVENT from './event';

export const COMMON_LINKS = {
  ...ACCOUNT,
  ...EXTERNAL,
  ...PROMO,
  ...STORE,
  ...PLATFORM,
  ...USER,
  ...CMS,
  ...CUSTOMER,
  ...DOCUMENT,
  ...FAQ,
  ...EVENT,
};
